// ActivitieCarousel.tsx
"use client";

import PosterCardSkeleton from "@/components/skeletons/card/PosterCardSkeleton";
import TourActivityCard from "@/components/card/TourActivityCard";
import HomeCarouselSection from "../../HomeCarouselSection";
import { useTourActCarousel } from "@/hooks/tour-act/useTourAndActivity";
import { TourActCarouselItem } from "@/components/main-services/tour-act/tour.type";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useInView } from "@/hooks/useObserver";

interface ActivitieCarouselProps {
  title: string;
  icon?: string;
  href?: string;
  type?: "tour" | "activity";
}

const ActivitieCarousel = ({
  title,
  icon,
  href,
  type,
}: ActivitieCarouselProps) => {
  const [containerRef, inView] = useInView("300px");
  const isMdUp = useMediaQuery("(min-width: 768px)");
  const { data: tourAct, isFetching, isError } = useTourActCarousel(inView);

  const items = type
    ? tourAct?.items?.filter((item: { type: string }) => item.type === type)
    : tourAct?.items;

  if (inView && !isFetching && items?.length === 0) return null;

  return (
    <div ref={containerRef}>
      <HomeCarouselSection<TourActCarouselItem>
        title={title}
        icon={icon}
        href={href}
        items={items}
        isFetching={isFetching}
        isError={isError}
        getKey={(item) => item.id}
        itemsPerCol={isMdUp ? 4 : 3}
        renderItem={(item) => <TourActivityCard data={item} />}
        renderSkeleton={() => <PosterCardSkeleton />}
      />
    </div>
  );
};

export default ActivitieCarousel;
